import { InlineTextButton, Space, Spacer, WarningAlert } from '@procurify/ui'
import { useDispatch, useSelector } from 'react-redux'

import { clearFFOverrides } from '@webapp/core/services/FeatureFlag'
import { updateFlags } from '@webapp/core/stores/global'
import { updateHasFFOverride } from './stores/actions'
import {
  makeSelectHasFFOverride,
  makeSelectLiveFFState,
} from './stores/selectors'

export interface IProcurifyDevToolsFfWarningProps {}

export const ProcurifyDevToolsFfWarning = ({
  ...props
}: IProcurifyDevToolsFfWarningProps) => {
  const hasFFOverride = useSelector(makeSelectHasFFOverride())
  const liveFFState = useSelector(makeSelectLiveFFState())

  const dispatch = useDispatch()

  const clearOverrides = () => {
    clearFFOverrides()

    dispatch(updateHasFFOverride(false))
    dispatch(updateFlags(liveFFState))
  }

  return hasFFOverride ? (
    <>
      <WarningAlert>
        <Space direction='horizontal' justify='space-between'>
          <span>
            Frontend Application is currently overwritten by local Feature
            Flags.
          </span>
          <InlineTextButton onClick={clearOverrides}>
            Clear Overrides
          </InlineTextButton>
        </Space>
      </WarningAlert>
      <Spacer />
    </>
  ) : null
}

ProcurifyDevToolsFfWarning.displayName = 'ProcurifyDevToolsFfWarning'
